
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M7 19.0868C7 20.2324 8.30086 20.8931 9.22588 20.2173L18.893 13.1546C19.6571 12.5964 19.6588 11.4567 18.8964 10.8962L9.22927 3.78909C8.30473 3.10937 7 3.76954 7 4.91705L7 19.0868Z","fill":"#10001F"}})])
          )
        }
      }
    